import React from 'react';
import Hide from '@uber/base-icons/hide';
import { useStyletron } from 'baseui';
import { LabelLarge, ParagraphSmall } from 'baseui/typography';
export const EmptyState = ({
  size = 24,
  title,
  message
}: {
  size?: number;
  title?: string;
  message?: string;
}) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale200,
    flexDirection: 'column',
    paddingTop: theme.sizing.scale1000
  })}>
      <Hide size={size} color={theme.colors.contentPrimary} />
      {title && <LabelLarge margin={0} paddingTop={theme.sizing.scale300}>
          {title}
        </LabelLarge>}
      {message && <ParagraphSmall margin={0} className={css({
      textAlign: 'center'
    })}>
          {message}
        </ParagraphSmall>}
    </div>;
};